import { useEffect, useRef, useCallback, useState } from 'react';

export default function useStockfish(depth = 16) {
  const engineRef = useRef(null);
  const resolveRef = useRef(null);
  const resultRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const engine = new Worker('/stockfish.js');
    engineRef.current = engine;

    engine.onmessage = (e) => {
      const line = typeof e.data === 'string' ? e.data : e.data?.data;
      if (!line) return;
      console.log('[SF]', line);

      if (line === 'uciok') engine.postMessage('isready');
      if (line === 'readyok') setReady(true);

      if (line.startsWith('info') && line.includes(' score ')) {
        const cpMatch = line.match(/score cp (-?\d+)/);
        const mateMatch = line.match(/score mate (-?\d+)/);
        if (!resultRef.current) resultRef.current = {};
        if (cpMatch) resultRef.current.cp = parseInt(cpMatch[1], 10);
        if (mateMatch) {
          const m = parseInt(mateMatch[1], 10);
          resultRef.current.cp = m > 0 ? 10000 : -10000;
        }
      }

      if (line.startsWith('bestmove')) {
        const move = line.split(' ')[1];
        if (!resultRef.current) resultRef.current = {};
        resultRef.current.bestMoveUci = move;
        if (resolveRef.current) {
          resolveRef.current(resultRef.current);
          resolveRef.current = null;
        }
        resultRef.current = null;
      }
    };

    engine.onerror = (e) => console.error('[SF error]', e);
    engine.postMessage('uci');

    return () => {
      engine.postMessage('quit');
      engine.terminate();
      engineRef.current = null;
    };
  }, []);

  const evaluatePosition = useCallback((fen) => {
    const engine = engineRef.current;
    if (!engine) return Promise.resolve(null);

    return new Promise((resolve) => {
      resolveRef.current = resolve;
      resultRef.current = null;
      engine.postMessage('stop');
      engine.postMessage('position fen ' + fen);
      engine.postMessage('go depth ' + depth);
    });
  }, [depth]);

  const stop = useCallback(() => {
    engineRef.current?.postMessage('stop');
  }, []);

  return { evaluatePosition, stop, ready };
}
